// src/Components/ImportMarkers/DialogActionBar.js

import React from 'react';
import {
  Box,
  IconButton,
  Checkbox,
  FormControlLabel,
  Typography,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const circleBtnStyle = {
  width: '28px',
  height: '28px',
  border: '1px solid',
  borderColor: '#ccc',
  backgroundColor: 'transparent',
  color: '#333',
  transition: 'all 0.1s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderColor: '#999',
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent',
    borderColor: '#e0e0e0',
    color: '#ccc',
  },
};

export default function DialogActionBar({
  leftContent,
  applyToAllChecked,
  onApplyToAllChange,
  disableApplyToAll,
  onCancel,
  disableCancel,
  onUp,
  onDown,
  onPrev,
  onNext,
  disableNav,
  onOk,
  disableOk,
  isOkPressed,
  isLoadingOk,
}) {
  return (
    <Box
      sx={{
        mt: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: leftContent ? 'space-between' : 'flex-end',
        pt: 2,
        flexShrink: 0,
        width: '100%',
      }}>
      {leftContent && (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>{leftContent}</Box>
      )}

      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              size='small'
              checked={applyToAllChecked}
              disabled={disableApplyToAll}
              onChange={onApplyToAllChange}
              sx={{ p: 0.5, '&.Mui-checked': { color: '#1976d2' } }}
            />
          }
          label={
            <Typography variant='body2' sx={{ userSelect: 'none' }}>
              Apply to all
            </Typography>
          }
          sx={{
            m: 0,
            mr: 1,
            opacity: disableApplyToAll ? 0.3 : 1,
            transition: 'opacity 0.2s ease',
            pointerEvents: disableApplyToAll ? 'none' : 'auto',
          }}
        />

        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton
            disabled={disableNav}
            onClick={onUp}
            size='small'
            sx={circleBtnStyle}>
            <ArrowUpwardIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <IconButton
            disabled={disableNav}
            onClick={onDown}
            size='small'
            sx={circleBtnStyle}>
            <ArrowDownwardIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <Box sx={{ width: '4px' }} />
          <IconButton
            disabled={disableNav}
            onClick={onPrev}
            size='small'
            sx={circleBtnStyle}>
            <ArrowBackIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <IconButton
            disabled={disableNav}
            onClick={onNext}
            size='small'
            sx={circleBtnStyle}>
            <ArrowForwardIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        <IconButton
          onClick={onCancel}
          disabled={disableCancel}
          size='small'
          title='Cancel'
          sx={{
            color: '#d32f2f',
            ml: 1,
            '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.04)' },
            '&.Mui-disabled': { color: '#e0e0e0' },
          }}>
          <CancelIcon sx={{ fontSize: 32 }} />
        </IconButton>

        <IconButton
          onClick={onOk}
          disabled={disableOk}
          size='small'
          title='OK'
          sx={{
            color: '#4caf50',
            transform: isOkPressed ? 'scale(0.80)' : 'none',
            backgroundColor: isOkPressed ? 'rgba(76, 175, 80, 0.15)' : 'transparent',
            transition: 'all 0.1s ease',
            '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.04)' },
            '&.Mui-disabled': { color: '#e0e0e0' },
          }}>
          {isLoadingOk ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            <CheckCircleIcon sx={{ fontSize: 32 }} />
          )}
        </IconButton>
      </Box>
    </Box>
  );
}
